import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'webloyalty',
  props: {
    hash: null,
    ckw: null
  },
  setup(__props: any) {

const props = __props as {
  hash: string;
  ckw?: string;
};



const encode = (v: string): string => {
  let hex = "";
  for (let i = 0; i < v.length; i++) {
    hex += "" + v.charCodeAt(i).toString(16);
  }
  return hex;
}

onMounted(() => {
  // @ts-expect-error
  if (window.prodID?.a) {
    // @ts-expect-error
    window.prodID.a.push({ "h": encode(props.hash), "ckw": props.ckw, "r": false });
  }
});

return { __sfc: true,props, encode }
}

})